import { render, staticRenderFns } from "./rename_worklist_dialog.vue?vue&type=template&id=6561b527&scoped=true"
import script from "./rename_worklist_dialog.vue?vue&type=script&lang=js"
export * from "./rename_worklist_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561b527",
  null
  
)

export default component.exports